"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatValue = exports.formatNumber = exports.formatPercent = exports.formatPercent100 = exports.formatMoney = exports.formatRate = void 0;
const accounting = __importStar(require("accounting"));
const formatPercentValue = (value) => {
    if (!value) {
        return '0';
    }
    const valueMain = value ? Math.abs(Math.round(value)) : 0;
    if (valueMain > 0) {
        return accounting.formatNumber(valueMain, 0);
    }
    const valueDecimal = Math.max(Math.floor(value * 10) - valueMain * 10, 1);
    return `0.${valueDecimal}`;
};
const formatRate = (value) => {
    if (!value) {
        return '0.0x';
    }
    const valueMain = value ? Math.abs(Math.floor(value)) : 0;
    const valueDecimal = Math.floor(value * 10) - valueMain * 10;
    return `${valueMain}.${valueDecimal}x`;
};
exports.formatRate = formatRate;
const formatMoney = (value) => (value < 0 ? '-' : '') + accounting.formatMoney(Math.abs(value), undefined, 0);
exports.formatMoney = formatMoney;
const formatPercent100 = (value) => `${formatPercentValue(value)}%`;
exports.formatPercent100 = formatPercent100;
const formatPercent = (value) => exports.formatPercent100(value * 100);
exports.formatPercent = formatPercent;
const formatNumber = (value) => accounting.formatNumber(value, 0, ',');
exports.formatNumber = formatNumber;
const formatValue = (value, format) => {
    if (format === 'money') {
        return exports.formatMoney(value);
    }
    if (format === 'percent') {
        return exports.formatPercent(value);
    }
    if (format === 'percent-100') {
        return exports.formatPercent100(value);
    }
    if (format === 'number') {
        return exports.formatNumber(value);
    }
    if (format === 'rate') {
        return exports.formatRate(value);
    }
    return exports.formatNumber(value);
};
exports.formatValue = formatValue;
//# sourceMappingURL=formatters.js.map